import { render, staticRenderFns } from "./BookmarksApp.vue?vue&type=template&id=322a21a2&"
import script from "./BookmarksApp.vue?vue&type=script&lang=js&"
export * from "./BookmarksApp.vue?vue&type=script&lang=js&"
import style0 from "./assets/scss/main.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports